import { forbidden as forbiddenFunc, forbiddens as forbiddensFunc, } from "./forbidden";
import { createSquare, makeSquare, parseSquare, wrapSquare } from "./square";
export const createBoard = () => ({
    square: createSquare(),
});
export const makeBoard = (blacks, whites) => ({
    square: makeSquare(blacks, whites),
});
export const parseBoard = (s) => {
    const square = parseSquare(s);
    if (square === undefined) {
        return undefined;
    }
    else {
        return { square };
    }
};
export const wrapBoard = (self) => ({
    unwrap: () => self,
    put: put(self),
    remove: remove(self),
    stones: stones(self),
    rows: rows(self),
    rowsOn: rowsOn(self),
    forbidden: forbidden(self),
    forbiddens: forbiddens(self),
    toString: toString(self),
});
const put = (self) => (player, p) => wrapBoard({
    square: wrapSquare(self.square).put(player, p).unwrap(),
});
const remove = (self) => (p) => wrapBoard({
    square: wrapSquare(self.square).remove(p).unwrap(),
});
const stones = (self) => (player) => wrapSquare(self.square).stones(player);
const rows = (self) => (player, kind) => wrapSquare(self.square).rows(player, kind);
const rowsOn = (self) => (player, kind, p) => wrapSquare(self.square).rowsOn(player, kind, p);
const forbiddens = (self) => () => forbiddensFunc(self.square);
const forbidden = (self) => (p) => forbiddenFunc(self.square, p);
const toString = (self) => () => wrapSquare(self.square).toString();
//# sourceMappingURL=board.js.map